import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { BuildingSupplierSelectFormikField } from '../../../BuildingSupplierSelectFormikField'

function SupplierField({ name }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <BuildingSupplierSelectFormikField
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Building.SupplierPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Building.SupplierLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={name}
    />
  )
}

export default SupplierField
